export type SaveStatus =
  | { kind: 'idle' }
  | { kind: 'dirty' }
  | { kind: 'saving' }
  | { kind: 'saved'; at: number }
  | { kind: 'error'; message: string };

interface Props {
  status: SaveStatus;
  canPublish: boolean;
  onPublishClick(): void;
  publishLabel?: string;
}

export function AdminSaveBar({
  status,
  canPublish,
  onPublishClick,
  publishLabel = 'Publish to public tool',
}: Props) {
  let statusClass = 'adm-savebar__status';
  let statusText: string;
  switch (status.kind) {
    case 'idle':
      statusText = 'No unsaved changes';
      break;
    case 'dirty':
      statusText = 'Unsaved changes…';
      statusClass += ' adm-savebar__status--saving';
      break;
    case 'saving':
      statusText = 'Saving draft…';
      statusClass += ' adm-savebar__status--saving';
      break;
    case 'saved':
      statusText = 'Draft saved · ' + new Date(status.at).toLocaleTimeString();
      break;
    case 'error':
      statusText = 'Save failed: ' + status.message;
      statusClass += ' adm-savebar__status--error';
      break;
  }
  return (
    <div className="adm-savebar">
      <div className={statusClass}>
        <span className="adm-savebar__dot" />
        <span>{statusText}</span>
      </div>
      <div className="adm-savebar__actions">
        <button
          className="adm-btn adm-btn--primary"
          type="button"
          onClick={onPublishClick}
          disabled={!canPublish || status.kind === 'saving'}
        >
          {publishLabel}
        </button>
      </div>
    </div>
  );
}
